export enum MembershipRole {
  Leader = 'LEADER',
  Member = 'MEMBER',
  Parent = 'PARENT',
}
